import { useTranslations, useLocale } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import { useToast, Button } from "@a2z/ui";
import { intlLocale } from "@/lib/formatting/locale";

type Props = {
  url: string;
  expiresAt: string;
};

export function CheckoutLinkResult({ url, expiresAt }: Props) {
  const t = useTranslations();
  const locale = useLocale();
  const toast = useToast();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(t(keys.checkoutLinks.generatedToast));
    } catch {
      toast.error(t(keys.errors.generic));
    }
  };

  // Follow the UI locale — hardcoding "ar-SA" rendered Arabic-Indic dates
  // ("١٣ أغسطس") on the English portal.
  const expiryDate = new Date(expiresAt).toLocaleDateString(intlLocale(locale), {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return (
    <div className="flex flex-col gap-2 rounded-xl border border-[color:var(--border-light)] bg-[color:var(--surface)] p-4">
      <div className="flex flex-col gap-1">
        <span className="text-xs font-semibold text-[color:var(--text-muted)]">
          {t(keys.checkoutLinks.generatedUrlLabel)}
        </span>
        <p className="break-all text-sm text-[color:var(--text-primary)]">{url}</p>
      </div>
      <div className="text-xs text-[color:var(--text-muted)]">
        {t(keys.checkoutLinks.expiresLabel)}: {expiryDate}
      </div>
      <Button
        type="button"
        variant="outline"
        className="min-h-11 w-full"
        onClick={() => void handleCopy()}
      >
        {t(keys.checkoutLinks.copyButton)}
      </Button>
    </div>
  );
}
